import { useEffect, useState } from "react"

// Returns 0 on the first render, then settles to `target` after mount so that
// NumberFlow always plays its count-up animation on (re)mount / page refresh —
// otherwise the value renders already-final (since the cards mount only once
// their data has loaded) and NumberFlow has no transition to animate.
export const useAnimatedNumber = (target) => {
  const [value, setValue] = useState(0)

  useEffect(() => {
    setValue(Number(target) || 0)
  }, [target])

  return value
}

export default useAnimatedNumber
